module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "wrapper",
    staticClass: "wrapper"
  }, [_c('div', {
    ref: "shop",
    staticClass: "shop",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [(_vm.slides && _vm.slides.length) ? _c('div', {
    staticClass: "shadow",
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_c('slider', {
    attrs: {
      "slides": _vm.slides
    },
    on: {
      "on-img-tap": function($event) {
        return _vm.goBack()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "banner",
    staticClass: "banner"
  }), _vm._v(" "), (_vm.customer.isAdmin) ? _c('div', {
    staticClass: "for-customers"
  }, [_c('span', [_vm._v("服务用户：")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.forCustomer
    },
    on: {
      "change": _vm.forCustomersChange
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("请选择")]), _vm._v(" "), _vm._l((_vm.forCustomers), function(forCustomer) {
    return _c('option', {
      key: forCustomer._id,
      domProps: {
        "value": forCustomer._id
      }
    }, [_vm._v(_vm._s(forCustomer.name))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "contentContainer",
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "categories",
    class: {
      'fixed': _vm.fixed
    }
  }, [_c('ul', _vm._l((_vm.categories), function(category, index) {
    return _c('li', {
      key: category._id,
      class: {
        'selected': index == _vm.currentCategoryIndex
      },
      on: {
        "click": function($event) {
          return _vm.changeCategory(index, category)
        }
      }
    }, [_vm._v(_vm._s(category.name))])
  }), 0)]), _vm._v(" "), _c('ul', {
    ref: "goodsList",
    staticClass: "goods-list",
    on: {
      "scroll": _vm.goodsScroll
    }
  }, [_vm._l((_vm.categories), function(category) {
    return [_c('li', {
      ref: category._id || 'recenty_buy_category',
      refInFor: true,
      staticClass: "category-name"
    }, [_vm._v(_vm._s(category.name))]), _vm._v(" "), _vm._l((category.products), function(g) {
      return _c('li', [_c('div', {
        staticClass: "goods-container"
      }, [_c('img', {
        attrs: {
          "src": g.images[0]
        },
        on: {
          "click": function($event) {
            return _vm.showSlider(g)
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "goods-info"
      }, [_c('p', [_c('span', {
        staticClass: "goods-name"
      }, [_vm._v(_vm._s(g.name))])]), _vm._v(" "), _c('p', [_c('span', {
        staticClass: "goods-desc"
      }, [_vm._v(_vm._s(g.desc))])]), _vm._v(" "), _c('p', [_c('span', {
        staticClass: "goods-price"
      }, [_vm._v("¥" + _vm._s(Number(g.customerPrice || g.price).toFixed(1)))]), _c('span', {
        staticClass: "price-unit"
      }, [_vm._v("元/" + _vm._s(g.unit || '斤'))]), _vm._v(" "), _c('span', {
        staticClass: "count-btn add-btn",
        on: {
          "click": function($event) {
            return _vm.addCartNumber(g)
          }
        }
      }, [_vm._v("+")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.productCartNum[g._id]),
          expression: "productCartNum[g._id]"
        }],
        staticClass: "count-num",
        style: ({
          visibility: _vm.productCartNum[g._id] ? 'visible' : 'hidden'
        }),
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": (_vm.productCartNum[g._id])
        },
        on: {
          "change": function($event) {
            return _vm.alterNum(g, $event)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.productCartNum, g._id, $event.target.value)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "count-btn minus-btn",
        style: ({
          visibility: _vm.productCartNum[g._id] ? 'visible' : 'hidden'
        }),
        on: {
          "click": function($event) {
            return _vm.removeCartNumber(g)
          }
        }
      }, [_vm._v("-")])])])])])
    })]
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cartShow),
      expression: "cartShow"
    }],
    staticClass: "cart"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("购物车")]), _vm._v(" "), _c('span', {
    staticClass: "clear-goods",
    on: {
      "click": function($event) {
        return _vm.clearCart()
      }
    }
  }, [_c('i'), _vm._v("清空")])]), _vm._v(" "), _c('ul', _vm._l((_vm.cartGoods), function(g) {
    return _c('li', {
      key: g.id
    }, [_c('p', {
      staticClass: "cart-item"
    }, [_c('span', [_vm._v(_vm._s(g.name) + _vm._s(g.spec ? (" [" + (g.spec) + "]") : ""))]), _vm._v(" "), _c('span', {
      staticClass: "price"
    }, [_vm._v("¥" + _vm._s(Math.round(g.quantity * g.price * 100) / 100))]), _vm._v(" "), (g.unit2) ? _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("(约" + _vm._s(Number(g.quantity).toFixed(2)) + _vm._s(g.unit || '斤') + ")")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("    " + _vm._s(parseInt(g.quantity / (g.unit2 ? g.priceTransfer : 1))) + _vm._s(g.unit2 || g.unit || '斤'))])])])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cartShow),
      expression: "cartShow"
    }],
    staticClass: "masker",
    on: {
      "click": function($event) {
        _vm.cartShow = false;
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.specsShow),
      expression: "specsShow"
    }],
    staticClass: "masker",
    on: {
      "click": function($event) {
        _vm.specsShow = false;
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "time-masker"
  }, [_vm._m(0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.specsShow),
      expression: "specsShow"
    }],
    staticClass: "specs"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.currentProduct.name))]), _vm._v(" "), (_vm.currentProduct.unit2 && _vm.currentProduct.priceTransfer) ? _c('ul', {
    staticClass: "item-container"
  }, [_c('li', {
    staticClass: "item-title"
  }, [_vm._v("单位")]), _vm._v(" "), _c('li', {
    staticClass: "item",
    class: {
      'selected': _vm.currentProduct.unit2 !== _vm.currentUnit
    },
    on: {
      "click": function($event) {
        return _vm.selectUnit(_vm.currentProduct.unit)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.currentProduct.unit) + "\n      ")]), _vm._v(" "), _c('li', {
    staticClass: "item",
    class: {
      'selected': _vm.currentProduct.unit2 === _vm.currentUnit
    },
    on: {
      "click": function($event) {
        return _vm.selectUnit(_vm.currentProduct.unit2)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.currentProduct.unit2) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.currentProduct.specs && _vm.currentProduct.specs.length > 1) ? _c('ul', {
    staticClass: "item-container"
  }, [_c('li', {
    staticClass: "item-title"
  }, [_vm._v("规格")]), _vm._v(" "), _vm._l((_vm.currentProduct.specs), function(spec) {
    return _c('li', {
      key: spec,
      staticClass: "item",
      class: {
        'selected': spec === _vm.currentSpec
      },
      on: {
        "click": function($event) {
          return _vm.selectSpec(spec)
        }
      }
    }, [_vm._v("\n        " + _vm._s(spec) + "\n      ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-row"
  }, [_c('div', {
    staticClass: "button-container"
  }, [_c('span', {
    staticClass: "count-btn add-btn",
    on: {
      "click": function($event) {
        return _vm.addSpecToCart(_vm.currentProduct)
      }
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productCartNum[_vm.currentProduct._id]),
      expression: "productCartNum[currentProduct._id]"
    }],
    staticClass: "count-num",
    style: ({
      visibility: _vm.productCartNum[_vm.currentProduct._id] ? 'visible' : 'hidden'
    }),
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.productCartNum[_vm.currentProduct._id])
    },
    on: {
      "change": function($event) {
        return _vm.alterNum(_vm.currentProduct, $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.productCartNum, _vm.currentProduct._id, $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "count-btn minus-btn",
    style: ({
      visibility: _vm.productCartNum[_vm.currentProduct._id] ? 'visible' : 'hidden'
    }),
    on: {
      "click": function($event) {
        return _vm.removeSpecFromCart(_vm.currentProduct)
      }
    }
  }, [_vm._v("-")])])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-options"
  }, [_c('p', {
    staticClass: "goods-count",
    on: {
      "click": function($event) {
        return _vm.toggleCart()
      }
    }
  }, [_c('i'), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.productCartTotalNum))]), _c('span', {
    staticClass: "price"
  }, [_vm._v("¥" + _vm._s(_vm.totalPrice))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalPrice < 0.001),
      expression: "totalPrice < 0.001"
    }],
    staticClass: "min-fee"
  }, [_vm._v("起送金额" + _vm._s(_vm.minMoney) + "元")])]), _vm._v(" "), _c('button', {
    staticClass: "go-order",
    attrs: {
      "disabled": _vm.totalPrice < 0.001
    },
    on: {
      "click": function($event) {
        return _vm.goCheckout()
      }
    }
  }, [_vm._v("\n      立即下单\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "open-time"
  }, [_c('p', [_vm._v("本店打烊啦！")]), _vm._v(" "), _c('p', [_vm._v("营业时间6：00-23：30")]), _vm._v(" "), _c('p', [_vm._v("欢迎明日光临!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-79355a8a"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/Shop.vue
// module id = 546
// module chunks = 1